import { BaseAPI } from '../manager/base';
import { PlatformRecord } from '../../types/process/platform-record';

class PlatformRecordService extends BaseAPI<PlatformRecord> {
  constructor() {
    super('/platform-records');
  }
}

const platformRecordApi = new PlatformRecordService();
export default platformRecordApi;
